<template>
  <div class="custom-button-wrapper">
    <div v-if="skinType === 1" class="custom-button-component">
      <div class="button-content" @click="toGn(buttonName)">
        <div v-if="iconPosition === 'left' && iconUrl && normalDisplay" class="button-icon left-icon">
          <img v-lazy-load :data-not-lazy="$attrs.index < 2" v-lazy-load :data-src="iconUrl" :alt="buttonName" @error="failRendering">
        </div>
        <div class="button-text">
          {{ buttonName }}
        </div>
        <div v-if="iconPosition === 'right' && iconUrl && normalDisplay" class="button-icon right-icon">
          <img v-lazy-load :data-not-lazy="$attrs.index < 2" v-lazy-load :data-src="iconUrl" :alt="buttonName" @error="failRendering">
        </div>
      </div>
    </div>

    <a v-else :href="linkUrl" :target="target" class="custom-button-component">
      <div class="button-content" @click="buttonTrackReport({ buttonName })">
        <div v-if="iconPosition === 'left' && iconUrl && normalDisplay" class="button-icon left-icon">
          <img v-lazy-load :data-not-lazy="$attrs.index < 2" v-lazy-load :data-src="iconUrl" :alt="buttonName" @error="failRendering">
        </div>
        <div class="button-text">
          {{ buttonName }}
        </div>
        <div v-if="iconPosition === 'right' && iconUrl && normalDisplay" class="button-icon right-icon">
          <img v-lazy-load :data-not-lazy="$attrs.index < 2" v-lazy-load :data-src="iconUrl" :alt="buttonName" @error="failRendering">
        </div>
      </div>
    </a>
  </div>
</template>

<script>
/**
 * 按钮组件
 */
import mixin from './mixin'
import trackReportMixin from '../Common/CommonMixin/trackReport'
import bus from 'common/bus'

export default {
  name: 'CustomButton',
  mixins: [mixin, trackReportMixin],
  methods: {
    toGn(buttonName) {
      this.buttonTrackReport({ buttonName })
      if (!this.isLogin) {
        if (this.feature === 'triageDesk') {
          bus.$emit('login', { triggerSource: 'down' });
          return
        }
        bus.$emit('login', { triggerSource: 'appointment' });
        return
      }
      if (this.feature === 'triageDesk' && this.triageComponentId) {
        this.$router.push(`/triage-desk/${this.triageComponentId}`);
        return
      }
      bus.$emit('toShowDiagnosis')
    },
  },
}
</script>
<style lang="scss" scoped>
@import './common.scss';

.custom-button-wrapper .custom-button-component {
  width: 392px;
}

.button-text {
  font-size: 22px;
  font-family: Roboto-Flex, sans-serif;
  font-weight: 600;
}
</style>
